import { Controller } from "@hotwired/stimulus";

class ScrollToTopController extends Controller {
  static targets = ["scroll"];

  declare readonly hasScrollTarget: boolean;
  declare readonly scrollTarget: HTMLButtonElement;
  declare readonly scrollTargets: HTMLButtonElement[];

  scroll() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

export default ScrollToTopController;
